<ion-content class="ion-padding">
  <curbnturf-login [inModal]="true"></curbnturf-login>
</ion-content>
